AgrimarketServices.service('quoteCashHashtagriService', ['$rootScope', '$http', '$location', 'configurationFactory',
    function ($rootScope, $http, $location, configurationFactory) {

        var SendRequest = function (configfile, callback) {
            $http(configfile)
			    .success(function (data) {
			        callback(data, null, null, null);
			    })
			    .error(function (data, status, headers, config) {
			        callback(data, status, headers, config);
			    });
        };

        this.SaveCashMarkets = function (collection, callback) {
            var config = {
                method: 'POST',
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/SaveCashMarkets',
                data: collection
            };
            SendRequest(config, callback);
        };

        this.GetCashMarketsSelected = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/GetCashMarketsSelected'
            };
            SendRequest(config, callback);
        };

        this.GetCashMarketsFromWsdApi = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/GetCashMarketsFromWsdApi'
            };
            SendRequest(config, callback);
        };


        this.GetHistoCashForGraphByIdExpiryFromWsdApi = function (idExpiry, callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/GetHistoCashForGraphByIdExpiryFromWsdApi',
                params: {
                    idExpiry: idExpiry
                }
            };
            SendRequest(config, callback);
        };


          this.SaveGroupContactsOfMarketCash = function (IdMarketWsd, lstIdGroupContacts, callback) {
            var config = {
                method: 'POST',
                data: lstIdGroupContacts,
                params: {
                    IdMarketWsd: IdMarketWsd
                },
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/SaveGroupContactsOfMarketCash'
            };
            SendRequest(config, callback);
        };

        this.GetGroupContactsByIdMarketWsd = function (IdMarketWsd, callback) {
            var config = {
                method: 'GET',
                params: {
                    IdMarketWsd: IdMarketWsd
                },
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/GetGroupContactsByIdMarketWsd'
            };
            SendRequest(config, callback);
        };

         this.GetGroupProductWsds = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/GetGroupProductWsds'
            };
            SendRequest(config, callback);
        };

         this.SetGroupProductWsd = function (label, idProductWsd, lstLabelGroupProductWsdToDeletes ,callback) {
            var config = {
                method: 'POST',
                data: {
                    Label: label,
                    IdProductWsd: idProductWsd,
                    LstLabelGroupProductWsdToDeletes : lstLabelGroupProductWsdToDeletes
                },
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/SetGroupProductWsd'
            };
            SendRequest(config, callback);
        };

        
        this.GetProductWsdOrders = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/GetProductWsdOrders'
            };
            SendRequest(config, callback);
        };

        this.SaveProductWsdOrders = function (data, callback) {
            var config = {
                method: 'POST',
                data: data,
                url: configurationFactory.Url['Api'] + 'QuoteCashHashtagri/SaveProductWsdOrders'
            };
            SendRequest(config, callback);
        };
    }]);